export default __webpack_public_path__ + "static/media/logo.78083524.png";